/**
 * page : 공지사항
 */

import { useEffect, useState } from 'react';
import { Link } from "react-router-dom";
import * as zy from '../common/zeroyear-1.0.0';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import Table from 'react-bootstrap/Table';
import Card from 'react-bootstrap/Card';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Swal from "sweetalert2";
let sessionStorage = window.sessionStorage;

const dataObject = {NOTICE_SEQ: '',NOTICE_NO: '',NOTICE_TITLE: '',NOTICE_CONTENT: ''};
export default function NoticePage () {
    const [admin, setAdmin] = useState(false);
    const [loading, setLoading] = useState(true);
    const [notice, setNotice] = useState([]);
    const [noticeImg, setNoticeImg] = useState([]);
    const [editImgs, setEditImgs] = useState([]);
    const [data, setData] = useState(dataObject);
    const [showModal, setShowModal] = useState(false);
    const [validated, setValidated] = useState(false);
    const selectAll = () => {
        zy.select('selectNoticeAll', [],(item) => {
            setNotice(item);
            setLoading(false);
            // zy.select('selectPerfImg', ['40'], (item) => {
            //     setNoticeImg(item);
            //     setPerfList(itemA);
            //     setLoading(false);
            // });
        });
    };
    useEffect(()=>{
        selectAll();
        setAdmin(sessionStorage.getItem('isLogin'));
    },[]);
    /**
     * close modal
     */
    const closeModal = () => {
        setValidated(false);
        setShowModal(false);
        setEditImgs([]);
    };
    /**
     * open modal
     */
    const openModal = () => {
        setValidated(false);
        setShowModal(true);
    };
    /**
     * 제목 change event
     */
    const changeTitle = (event) => {
        setData({...data, NOTICE_TITLE: event?.target.value});
    }/**
     * 내용 change event
     */
    const changeContent = (event) => {
        setData({...data, NOTICE_CONTENT: event?.target.value});
    }
    /**
     * 이미지 파일 change event
     */
    const changeImage = (event) => {
        let reader = new FileReader();
        reader.readAsDataURL(event.target.files[0]);
        reader.onload = function (e) {
            // setData({...data, PERF_IMG: e.target.result});
            setEditImgs([...editImgs, {...data, NOTICE_IMG_NO: editImgs.length+1,NOTICE_IMG: e.target.result}])
        }
    }
    const deleteImage = (event) => {
        setEditImgs(editImgs.filter((o) => o.NOTICE_IMG_NO != event.target.dataset.no));
        event.preventDefault();
        event.stopPropagation();
    }
    /**
     * 등록 event handler
     */
    const saveDesign = (event) => {
        const form = event.currentTarget;
        if (form.checkValidity() === false) {
            // validate
            event.preventDefault();
            event.stopPropagation();
        } else {
            // 저장
            event.preventDefault();
            event.stopPropagation();
            zy.create('insertNotice', [
                data.NOTICE_TITLE, data.NOTICE_CONTENT
            ], (item) => {
                if (item.affectedRows > 0) {
                    // 저장 완료
                    editImgs.forEach((img, iidx) => {
                        zy.create('insertNoticeImg', [
                            item.insertId, img.NOTICE_IMG
                        ], (itemB) => {
                            // 저장 완료
                            if (iidx+1 == editImgs.length) {
                                closeModal();
                                selectAll();
                            }
                        });
                    });
                }
            });
        }
        setValidated(true);
    };

    return (
        <>
        <main id="main">
            <section id="breadcrumbs" className="breadcrumbs">
                <div className="container">
                    <ol>
                        <li><a className="gg-font-color">고객센터</a></li>
                        <li>공지사항</li>
                    </ol>
                    <h2>공지사항</h2>
                </div>
            </section>
            <section id="portfolio-details" className="portfolio-details">
                <div className="container">
                    <div className="row gy-4">
                        <div className="col-lg-12">
                            <Table responsive="sm">
                                <thead>
                                    <tr>
                                        <th style={{width: '100px'}}>번호</th>
                                        <th style={{width: '150px'}}>제목</th>
                                        <th style={{width: '280px'}}>작성일시</th>
                                    </tr>
                                </thead>
                                <tbody>
                                {notice.length === 0 ? (
                                    <tr><td style={{ textAlign: 'center' }} colSpan={6}>등록된 공지사항이 없습니다.</td></tr>
                                ) : notice.map((noti) => (
                                    <tr key={noti.NOTICE_SEQ}>
                                        <td style={{width: '100px'}}>{noti.NOTICE_NO}</td>
                                        <td style={{width: '400px'}}><Link to={`/NoticeDetailRoute/${noti.NOTICE_SEQ}`}>{noti.NOTICE_TITLE}</Link></td>
                                        <td style={{width: '280px'}}>{noti.REG_DTM}</td>
                                    </tr>
                                ))}
                                </tbody>
                            </Table>
                        </div>
                    </div>
                    {
                        admin ? <button className="btn-normal" onClick={openModal} style={{float: 'right'}}>공지글 등록하기</button> : null
                    }
                </div>
            </section>

            <Modal 
                show={showModal}
                onHide={closeModal}
                backdrop="static"
                keyboard={false}
                size="lg"
                centered>
                <Form noValidate validated={validated} onSubmit={saveDesign}>
                    <Modal.Header closeButton>
                    <Modal.Title>공지사항</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form.Group className="d-input mb-3" controlId="NOTICE_TITLE">
                            <Form.Label>제목</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder=""
                                onChange={changeTitle}
                                required/>
                            <Form.Control.Feedback type="invalid">제목을 입력해주세요.</Form.Control.Feedback>
                        </Form.Group>
                        <Form.Group className="d-input mb-3" controlId="NOTICE_CONTENT">
                            <Form.Label>내용</Form.Label>
                            <Form.Control
                                as="textarea"
                                onChange={changeContent}
                                rows={6}
                                required/>
                            <Form.Control.Feedback type="invalid">내용을 입력해주세요.</Form.Control.Feedback>
                        </Form.Group>
                        <Form.Group className="d-input mb-3" controlId="Perf_TITLE">
                            <Form.Label>이미지 첨부</Form.Label>
                            <Form.Control
                                type="file"
                                accept="image/gif, image/jpeg, image/png"
                                onChange={changeImage}
                                placeholder=""/>
                            <Form.Control.Feedback type="invalid">이미지를 선택해주세요.</Form.Control.Feedback>
                        </Form.Group>
                        <div style={{marginBottom: '15px'}}>
                            <Row xs={2} md={4} className="g-4">
                                    {
                                        editImgs.map((perf) => {
                                            if (perf.DEL_YN !== 'Y') {
                                                return (
                                                    <Col key={perf.NOTICE_IMG_NO}>
                                                        <Card className='perf-card'>
                                                            <div className="perf-cards">
                                                                <Card.Img variant="top" src={perf.NOTICE_IMG} className="perf-card-img-eidt w-100"/>
                                                                <button className='perf-card-del' data-no={perf.NOTICE_IMG_NO} onClick={deleteImage}>X</button>
                                                            </div>
                                                        </Card>
                                                    </Col>
                                                );
                                            } else {
                                                return null;
                                            }
                                        })
                                    }
                            </Row>
                        </div>
                        <Modal.Footer>
                            <button className="btn-cancel" onClick={closeModal}>닫기</button>
                            <button className="btn-normal" type="submit">등록완료</button>
                        </Modal.Footer>
                    </Modal.Body>
                </Form>
            </Modal>
        </main>
        </>
    );
}